<ng-container>
  <span *ngIf="showServiceDate">{{ ticket.serviceDate | date: config.dateFormat }}</span>
  <span *ngIf="showServiceDateTime">
    {{ ticket.serviceTimeStart | date: config.dateTimeOnly  : 'UTC' }}
    &mdash;
    {{ ticket.serviceTimeEnd | date: config.dateTimeOnly : 'UTC'}}
  </span>
</ng-container>
